export enum SettingsAction {
  HideZeros = 'hideZeros',
  ShowYTD = 'showYTD',
  ShowChange = 'showChange',
  ShowGroupPercentage = 'showGroupPercentage',
}
